import { Type } from "@sinclair/typebox";

//#region src/shared/bricks/props/color.ts
function color(options = {}) {
	return Type.String({
		title: "Text color",
		"ai:instructions": "Format is `text-<variant>-<shade>`, variants being `primary`, `secondary`, `accent` and `neutral`, and shades between 50 and 900",
		pattern: "^text-(primary|secondary|accent|neutral|base|inherit|current)-?(50|100|200|300|400|500|600|700|800|900)?$",
		"ui:styleId": "styles:color",
		"ui:field": "color",
		"ui:color-type": "text",
		...options
	});
}
function borderColor(options = {}) {
	return Type.String({
		title: "Border color",
		"ai:instructions": "Format is `border-<variant>-<shade>`, variants being `primary`, `secondary`, `accent` and `neutral`, and shades between 50 and 900",
		pattern: "^border-(primary|secondary|accent|neutral|base|current)-?(50|100|200|300|400|500|600|700|800|900)?$",
		"ui:styleId": "styles:borderColor",
		"ui:field": "color",
		"ui:color-type": "border",
		...options
	});
}

//#endregion
export { borderColor, color };
//# sourceMappingURL=color.js.map